import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../util/reactIntl';
import { isHTMLString } from '../../../util/data';
import css from './IntroText.module.css';

const MAX_LENGTH = 300; // Characters before truncation

// Helper function to check if a string is empty or whitespace-only
const isEmptyOrWhitespace = (str) => {
    if (!str || typeof str !== 'string') return true;
    return str.trim().length === 0;
};

const IntroText = ({ storeAbout, seoDescription, storeName }) => {
    const [showFull, setShowFull] = useState(false);

    // SEO/AIO always overrides About Store
    // Use seoDescription if available and not empty, otherwise fallback to storeAbout
    const content = !isEmptyOrWhitespace(seoDescription)
        ? seoDescription
        : (!isEmptyOrWhitespace(storeAbout) ? storeAbout : null);

    // Return null if no content available
    if (!content) {
        return null;
    }

    const shouldTruncate = content.length > MAX_LENGTH;
    const displayText = shouldTruncate && !showFull
        ? content.substring(0, MAX_LENGTH) + '…'
        : content;

    return (
        <div className={css.root}>
            {isHTMLString(displayText) ? (
                <div
                    className={css.content}
                    dangerouslySetInnerHTML={{ __html: displayText }}
                />
            ) : (
                <p className={css.content}>{displayText}</p>
            )}
            {shouldTruncate && (
                <button
                    className={css.readMoreButton}
                    onClick={() => setShowFull(!showFull)}
                    type="button"
                >
                    {showFull ? (
                        <FormattedMessage id="StoreProfilePage.readLess" defaultMessage="Read less" />
                    ) : (
                        <>
                            <FormattedMessage id="StoreProfilePage.readMore" defaultMessage="Read more" />
                            <span className={css.arrow}>→</span>
                        </>
                    )}
                </button>
            )}

        </div>
    );
};

IntroText.propTypes = {
    storeAbout: PropTypes.string,
    seoDescription: PropTypes.string,
    storeName: PropTypes.string,
};

export default IntroText;

